
import Link from '@mui/material/Link';
import appStore from '../../../assets/icons/aapStore.png';
import googlePlay from '../../../assets/icons/googlePlay.png';
import logo from '../../../assets/icons/logo-white.svg';
import fbIcon from '../../../assets/icons/icon-fb.png';
import instaIcon from '../../../assets/icons/icon-insta.png';
import linkedIn from '../../../assets/icons/icon-linkedIn.png';
import ticktokIcon from '../../../assets/icons/icon-ticktok.png';
import youtubeIcon from '../../../assets/icons/icon-youtube.png';

const Footer = () => {
    return (
    <div className='footer-wrapper' >
      <div className='c_container' >
        <div className='d-flex justify-content-between footer-header' >
          <div className='footer-logo' >
            <img src={logo} alt='logo' />
          </div>
          <div className='footer-links' >
            <div className='d-flex align-items-center gap-20'>
                <a
                  href='https://www.facebook.com/corevitalsuk/?rdid=FXdTZcuj94Arelc6'
                  target='_blank'
                  rel='noreferrer'
                >
                  <img src={fbIcon} alt='Facebook' />
                </a>
                <a
                  href='https://www.instagram.com/core.vitals?igsh=Y2tza3Rza3J0cTJt&utm_source=qr'
                  target='_blank'
                  rel='noreferrer'
                >
                  <img src={instaIcon} alt='Instagram' />
                </a>
                <a
                  href='https://www.linkedin.com/company/core-vitals'
                  target='_blank'
                  rel='noreferrer'
                >
                  <img src={linkedIn} alt='LinkedIn' />
                </a>
                <a
                  href='https://www.tiktok.com/@core_vitals?_t=ZM-8ugFnIUI5cV&_r=1'
                  target='_blank'
                  rel='noreferrer'
                >
                  <img src={ticktokIcon} alt='Ticktok' />
                </a>
                <a
                  href='https://www.youtube.com/@core.vitals'
                  target='_blank'
                  rel='noreferrer'
                >
                  <img src={youtubeIcon} alt='Youtube' />
                </a>
              </div>
          </div>
        </div>
        <div className='footer-download-app' >
          <h4>Download the CoreVitals app</h4>
          <div className='d-flex gap-20' >
            <Link href='https://play.google.com/store/apps/details?id=me.corevitals.app&pli=1' target='_blank' >
              <img src={googlePlay} alt='google-play' />
            </Link>
            <Link href='https://apps.apple.com/us/app/corevitals/id6746760510' target='_blank' >
            <img src={appStore} alt='app-store' />
            </Link>
          </div>
  
        </div>
        <p className='footer-text'> CoreVitals is not a diagnostic service, primary care provider, or replacement for your existing medical care. We partner with accredited labs for blood analysis,
        but we do not diagnose conditions, and you should not change your medications or healthcare plan without consulting your doctor.</p>
      </div>
    </div>
    )
  }

  export default Footer;